import React, { useState, useEffect } from 'react'
import CookieConsentBanner from './CookieConsentBanner'

const COOKIE_CONSENT_KEY = 'interax_cookie_consent'

/**
 * CookieConsentBannerContainer Component
 *
 * Container component that manages cookie consent state and localStorage persistence
 * Only shows the banner when consent hasn't been given
 */
export const CookieConsentBannerContainer: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    // Check if consent has been accepted
    // Show banner if no consent OR if rejected (user rejected, ask again on every visit)
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY)
    if (!consent || consent === 'rejected') {
      // Small delay to ensure smooth page load
      const timer = setTimeout(() => {
        setShowBanner(true)
      }, 500)
      return () => clearTimeout(timer)
    }
    return undefined
  }, [])

  const handleAccept = () => {
    // Store accepted - banner won't show again
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted')
    setShowBanner(false)
  }

  const handleReject = () => {
    // Store rejected but still show on every visit
    localStorage.setItem(COOKIE_CONSENT_KEY, 'rejected')
    setShowBanner(false)
  }

  if (!showBanner) {
    return null
  }

  return <CookieConsentBanner onAccept={handleAccept} onReject={handleReject} />
}

export default CookieConsentBannerContainer
